import React, { FC, useCallback, useMemo, useRef } from 'react';

import { Button } from 'devextreme-react/button';
import DataGrid, { Column, Editing, Form, Pager, Paging, Popup, RequiredRule } from 'devextreme-react/data-grid';
import { Item } from 'devextreme-react/form';
import 'devextreme-react/text-area';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import CustomStore from 'devextreme/data/custom_store';
import { requestHelper } from 'utils/request-helper';

type NomenclatureCompositionPageProps = {
  initialId: number | null;
};

const NomenclatureCompositionPage: FC<NomenclatureCompositionPageProps> = ({ initialId }) => {
  const NomenclatureDataStore: any = useMemo(
    () =>
      new CustomStore({
        key: 'id',
        load: (loadOptions: any) => requestHelper(`/v1/NomenclatureCustomName/${initialId}`, 'get', loadOptions),
        insert: async (values) => {
          await requestHelper(`/v1/NomenclatureCustomName/${initialId}`, 'post', {
            values: values,
          });
        },

        remove: async (key) =>
          await requestHelper(`/v1/NomenclatureCustomName/${key}`, 'delete', {
            key: key,
          }),

        update: async (key, values) =>
          await requestHelper(`/v1/NomenclatureCustomName/${key}`, 'put', {
            key: key,
            values: values,
          }),
      }),
    [initialId],
  );

  const refGrid = useRef<DataGrid | null>(null);
  const addRow = useCallback(() => refGrid.current?.instance.addRow(), []);

  return (
    <div className="mt-4">
      <AppLayoutTop title="Обозначения марок">
        <Button width={120} text="Создать" type="default" onClick={addRow} />
      </AppLayoutTop>

      <AppCard>
        <DataGrid
          dataSource={NomenclatureDataStore}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
          onRowUpdating={(e) => (e.newData = { ...e.oldData, ...e.newData })}
          onInitNewRow={(e) => (e.data = { materialId: null, unitName: '', quantity: undefined })}
          searchPanel={{
            visible: false,
          }}
        >
          <Editing
            mode="popup"
            allowUpdating={true}
            texts={{
              editRow: 'Просмотр',
            }}
            allowDeleting={true}
          >
            <Popup title="Просмотр информации" showTitle={true} width={400} height="auto" />
            <Form>
              <Item itemType="group" colCount={2} colSpan={2}>
                <Item dataField="name" caption="Наименование" colSpan={2}>
                  <RequiredRule message="Заполните поле" />
                </Item>
              </Item>
            </Form>
          </Editing>

          <Column dataField="name" caption="Наименование" />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default NomenclatureCompositionPage;
